// extracted by mini-css-extract-plugin
module.exports = {"box":"FJButtonCircleIcon_box__3nAkB","default":"FJButtonCircleIcon_default__2xJGl","primary":"FJButtonCircleIcon_primary__2Gz3m"};